import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { Method } from 'axios';
import _ from 'lodash';
import {
  ProductOptionCategoryObject,
  ProductOptionCategoryProductOptionObject,
} from '../types/joostconnector';
import { Request } from './base/Request';

export class UpdateCartItemRequest extends Request<
  unknown,
  {
    product: unknown;
    item: unknown;
    form_key: unknown;
    mediaclip_product_id: string;
    mediaclip_project_id: string;
    product_sku: string;
    extra_options: {
      sku: string;
      name: string;
      display_name: string;
      label: string;
    }[];
    filters: { label: string; value: string }[];
    cart: Record<string, unknown>;
    mediaclip_preview_url: string;
  }
> {
  protected headers = {
    'Content-Type': 'multipart/form-data',
  };

  getResponse() {
    // `hyva` is injected by hyva theme in magento, this is not known to vue
    // @ts-ignore
    this.data.form_key = hyva.getFormKey();

    // Request cart needs to contain something (anything) for the update event to trigger
    const quoteItemId = useConfiguratorStore().quoteItemId;
    if (!quoteItemId) {
      throw new Error("Can't update, we don't have a quote item id");
    }
    this.data.cart = {};
    this.data.cart[quoteItemId] = { item_id: quoteItemId };

    return super.getResponse();
  }

  protected getEndPoint(): string {
    return window.update_url;
  }

  protected getMethod(): Method {
    return 'POST';
  }

  public setMagentoProductId(productId: number): this {
    this.data.product = productId;
    this.data.item = productId;
    return this;
  }

  public setMediaclipProductId(mediaclipProductId: string): this {
    this.data.mediaclip_product_id = mediaclipProductId;
    return this;
  }

  public setMediaclipProjectId(mediaclipProjectId?: string): this {
    if (mediaclipProjectId) {
      this.data.mediaclip_project_id = mediaclipProjectId;
    }
    return this;
  }

  public setSelectedProductSku(productSku: string): this {
    this.data.product_sku = productSku;
    return this;
  }

  public setExtraOptions(
    extraOptions: Record<number, ProductOptionCategoryProductOptionObject>,
    productOptionCategories: ProductOptionCategoryObject[]
  ): this {
    // @ts-ignore TS2345
    this.data.extra_options = _.map(
      extraOptions,
      (extraOption: ProductOptionCategoryProductOptionObject, key: number) => {
        // Find category by id
        const category = _.find(
          productOptionCategories,
          (productOptionCategory: ProductOptionCategoryObject) =>
            productOptionCategory.id === Number(key)
        ) as ProductOptionCategoryObject;

        // Merge the extra option data plus the category name
        return _.merge(_.pick(extraOption, ['sku', 'name', 'displayName']), {
          label: category.name,
        });
      }
    );
    return this;
  }

  public setFilters(filters: { label: string; value: string }[]): this {
    this.data.filters = filters;
    return this;
  }

  public setMediaclipPreviewUrl(mediaclipPreviewUrl: string): this {
    this.data.mediaclip_preview_url = mediaclipPreviewUrl;
    return this;
  }
}
